import { setTestCookies, removeTestCookies } from '@packages/abtesting';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { UseAbTestingCookiesFromEpsFragmentFragmentDoc } from '@packages/gql/generated/shopping/UseAbTestingCookiesFromEpsFragmentFragmentDoc';
import { useCookies } from '@packages/utilities';
import { useEffect } from 'react';

/* GraphQL */ `
  fragment UseAbTestingCookiesFromEpsFragment on EpsQueryResult {
    ... on SearchResultBase {
      abTesting {
        newTestAssignments {
          testId
          participantId
          variant {
            attribute
            value
          }
        }
        expiredTestIds
      }
    }
  }
`;

export const useAbTestingCookiesFromEps = (
  maskedData?: FragmentType<typeof UseAbTestingCookiesFromEpsFragmentFragmentDoc>,
) => {
  const { getCookies, setCookie, destroyCookie } = useCookies();
  const cookies = getCookies();

  const data = maskedData
    ? getFragmentData(UseAbTestingCookiesFromEpsFragmentFragmentDoc, maskedData)
    : undefined;

  useEffect(() => {
    const { newTestAssignments, expiredTestIds } =
      (data && 'abTesting' in data && data.abTesting) || {};

    if (newTestAssignments) {
      newTestAssignments.forEach(({ testId, participantId: participant, variant }) => {
        setTestCookies({
          testId,
          cookies,
          setCookie,
          value: {
            participant,
            variant: Object.fromEntries(variant.map(({ attribute, value }) => [attribute, value])),
          },
        });
      });
    }

    if (expiredTestIds) {
      expiredTestIds.forEach((testId) => {
        removeTestCookies({ testId, removeCookie: destroyCookie });
      });
    }
  }, [data, cookies, destroyCookie, setCookie]);
};
